import { render, staticRenderFns } from "./ContextFavorecido.vue?vue&type=template&id=1b09df26&"
import script from "./ContextFavorecido.vue?vue&type=script&lang=ts&"
export * from "./ContextFavorecido.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports